module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAuUlEQVR4Ae3TtRlCMRiF4QMT4LInPfRMgLMCNg4VbgvgJRXPl5sfJyd1zhvVT6Wggba6RBzOSWrOdRagq8tzgc2TAZgAeRIQgKz68C/KFiCpqS44Sv5AHaqBYGAMxRUgEDgAIFWBsAJA2AEg7AAQCBwZYMIMMGEAgEDgxAATJuA+8SzgRtgBxhk4BwAAqAhAADDPB2JvBwIQDwBn5l0/dQO63kDbDchq7rn+pBxT1Ei7SOUbDVTQj+UKCrF/5F0Rs90AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Dashboard/baseline_file_copy_black_24dp.png
// module id = 130
// module chunks = 0